export default __webpack_public_path__ + "static/media/screensMade.8fce86a5.svg";